import React from 'react';
import { Rail } from '@stashinvest/react-components';

type MobileNavProps = {
	navOptions?: unknown[];
	selectedIndex?: number | null;
	onNavLinkClick?: (index?: number) => void;
};

export const MobileNav = ({
	navOptions = [],
	selectedIndex,
	onNavLinkClick,
}: MobileNavProps) => {
	return (
		<nav className="fixed bottom-0 z-[11] block h-[var(--mobile-nav-height)] w-full bg-background shadow-[0_2px_4px_0_rgba(0,0,0,0.2)] gridLarge:hidden">
			<Rail
				selectedIndex={selectedIndex ?? 0}
				onIndexSelect={(index) => {
					onNavLinkClick?.(index);
				}}
				navItems={
					navOptions as React.ComponentProps<typeof Rail>['navItems']
				}
				onLogoClick={() => undefined}
			/>
		</nav>
	);
};

export default MobileNav;
